import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { ENFORCE_FIELD_LEVEL_PERMISSIONS, SUPPORT_SELECTING_SENSITIVE_PROPERTIES } from 'automation-ui-formula-editor/constants/Gates';
import { useDataPassingContext } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import PropertyTagTooltip from 'automation-ui-formula-editor/data-passing-panel/Inputs/PropertyTagTooltip';
import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { ACTION_OUTPUTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import { getPropertyIcon } from 'automation-ui-formula-editor/data-sources/utils/getPropertyIcon';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import FormulaEditorTokenTag from 'automation-ui-formula-editor/formula-editor/FormulaEditorTokenTag';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DataTokenMark = ({
  'data-test-id': dataTestId,
  clearable,
  formattedToken,
  onClearInput,
  readOnly,
  use
}) => {
  const handleCloseClick = () => {
    onClearInput === null || onClearInput === void 0 || onClearInput(formattedToken);
  };
  const {
    state: {
      searchForDataTokenCallback
    }
  } = useDataPassingContext();
  const isGatedToSupportSelectingSensitiveProperties = !useIsUngated(SUPPORT_SELECTING_SENSITIVE_PROPERTIES);
  const enforceFlp = useIsUngated(ENFORCE_FIELD_LEVEL_PERMISSIONS);
  const {
    prefix,
    property
  } = getTokenParts(formattedToken);
  const {
    data,
    loading,
    error
  } = useGetDataProperty({
    prefix,
    property
  });
  const {
    dataSourceDefinition,
    dataSourceProperty
  } = data || {};
  const propertyIconName = getPropertyIcon({
    dataSensitivityAllowlist: isGatedToSupportSelectingSensitiveProperties ? ['none'] : undefined,
    dataProperty: dataSourceProperty,
    enforceFlp
  });
  if (loading) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: property
    });
  }
  if (error || !data || !dataSourceDefinition || !dataSourceProperty) {
    let erroredProps = {
      'data-test-id': dataTestId,
      closeable: clearable,
      label: I18n.text('automation-ui-formula-editor.data-passing-panel.single-value-input.error'),
      onCloseClick: handleCloseClick,
      TooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.error"
      }),
      useError: true
    };
    if (data && !dataSourceProperty && (dataSourceDefinition === null || dataSourceDefinition === void 0 ? void 0 : dataSourceDefinition.dataSourceType) === DataSourceType.ACTION_OUTPUT) {
      erroredProps = Object.assign({}, erroredProps, {
        label: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.single-value-input.deleted-output-field",
          options: {
            actionName: dataSourceDefinition.label
          }
        }),
        TooltipContent: () => /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.single-value-input.deleted-output-field",
          options: {
            actionName: dataSourceDefinition.label
          }
        })
      });
    }

    // Assuming if the data is missing but the prefix is an action output, the action has been deleted
    if (!data && prefix.startsWith(ACTION_OUTPUTS)) {
      erroredProps = Object.assign({}, erroredProps, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.single-value-input.deleted-source"
        }),
        TooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.deleted-action"
        })
      });
    }
    return /*#__PURE__*/_jsx(FormulaEditorTokenTag, Object.assign({}, erroredProps));
  }
  const propertyLabel = dataSourceProperty.label || '';
  const conditionalProps = searchForDataTokenCallback ? {
    onClickSearchForToken: () => searchForDataTokenCallback({
      prefix,
      propertyLabel: propertyLabel
    })
  } : undefined;
  const TooltipContent = () => /*#__PURE__*/_jsx(PropertyTagTooltip, {
    data: data
  });
  return /*#__PURE__*/_jsx(FormulaEditorTokenTag, Object.assign({}, conditionalProps, {
    closeable: clearable,
    "data-test-id": dataTestId,
    label: propertyLabel,
    onClickRemoveToken: handleCloseClick,
    onCloseClick: handleCloseClick,
    propertyIconName: propertyIconName,
    readOnly: readOnly,
    TooltipContent: TooltipContent,
    use: use,
    useError: !dataSourceProperty
  }));
};
export default DataTokenMark;